import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AppSettingsService } from './appsettings.service';

@Injectable()
export class StorageService {

	private prefix = '';

	constructor(private storage: Storage, private platform: Platform, appsettingsService: AppSettingsService) {
		this.prefix += appsettingsService.Get('currentHost') + '_';
	}

  async create(): Promise<Storage> {
    return await this.storage.create();
  }

  getStore(): Promise<any> {
    return this.storage.get('store');
  }

  removeStore(): Promise<void> {
    return this.storage.remove('store');
  }

	// Device-local, deliberately not synced to the backend - this only gates whether the one-time
	// permissions primer modal has been shown, not the actual OS permission state (which the
	// browser/OS already remembers on their own).
	hasShownPermissionsOnboarding(): Promise<boolean> {
		return this.platform.ready().then(() => this.storage.get(this.prefix + 'permissions_onboarding_shown')).then(value => !!value);
	}

	setShownPermissionsOnboarding(): Promise<any> {
		return this.platform.ready().then(() => this.storage.set(this.prefix + 'permissions_onboarding_shown', true));
	}
}
